//初始化state
const state = {
}
  
  //定义getter
  const getters = {
    
  }

  //定义同步的操作，即mutation
const mutations = {
}

//定义异步的操作，即action
const actions = {
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
  }